import { pick } from 'lodash';

import { getDefaultCustomPeriod } from '@react/Common/CustomPeriod/CustomPeriod.utils';

function CustomPeriod($timeout, $location, TimeSpan) {
  'ngInject';

  const _allowedParams = ['cohort_period_filter', 'period'];

  let _params = {};
  let _timezone = null;

  return {
    init: init,
    preserve: preserve,
    getParams: getParams,
    getTimezone: getTimezone,
    resetCustomPeriod: resetCustomPeriod
  };

  /**
   * Set params for 'period' and 'cohort_period_filter' based on statistics tab
   *
   * @param {String} screen
   */
  function init(screen, timezone) {
    if (screen !== 'cohorts') {
      _params = {};
      return;
    }

    const { from } = TimeSpan.getParams();
    const { period = 'day', cohort_period_filter } = _decodeParams();

    _timezone = timezone;

    return $timeout(() => {
      _params = {
        period,
        cohort_period_filter:
          cohort_period_filter || getDefaultCustomPeriod(from, period, timezone)
      };
    });
  }

  /**
   * Get parameters allowed to be changed
   *
   * @returns {Object}
   * @private
   */
  function _decodeParams() {
    return pick($location.search(), _allowedParams);
  }

  /**
   * Get currently set parameters
   *
   * @returns {Object}
   */
  function getParams() {
    return _params;
  }

  /**
   * Get current timezone
   *
   * @returns {Object}
   */
  function getTimezone() {
    return _timezone;
  }

  /**
   * Update the params in url and global service object
   *
   * @param {Object} params
   * @param {String} params.period
   * @param {String} params.cohort_period_filter
   */
  function preserve({ period, cohort_period_filter }) {
    _params = {
      period,
      cohort_period_filter
    };

    // XXX: please don't set params by using `$location.search(params)` here, too many side effects due to the `$location.search` watch
    // HACK: $timeout is used because it appears that replace() replaces the entire route record when in current digest cycle
    $timeout(() => {
      $location.search('period', period).replace();
      $location.search('cohort_period_filter', cohort_period_filter).replace();
    });
  }

  /**
   * Reset the 'cohort_period_filter' param to default when range changes
   *
   * @param {Object} params
   * @param {String} params.to
   * @param {String} params.from
   */
  function resetCustomPeriod({ from }) {
    const params = {
      ..._params,
      cohort_period_filter: getDefaultCustomPeriod(from, _params.period, _timezone)
    };

    preserve(params);
  }
}

export { CustomPeriod };
